import React from 'react';
import PropTypes from 'prop-types';
import './SearchBar.css';

export const SearchBar = (props) => {
  const { placeholderText, onChange, value } = props;
  return (
    <input
      type="search"
      className="search-box"
      placeholder={placeholderText}
      value={value}
      onChange={(e) => onChange(e)}
    />
  );
};

/* eslint-disable react/forbid-prop-types */
SearchBar.propTypes = {
  placeholderText: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

SearchBar.defaultProps = {
  placeholderText: '',
  onChange: undefined,
  value: '',
};
